import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Skeleton } from "primereact/skeleton";
import TransactionAlert from "../../components/TransactionAlert";
import DashboardCard from "../../components/Cards/DashboardCards";
import { getOverAllCount } from "../../reducers/analyticSlice";

const loadingMetric = (
  <Skeleton width="7rem" height="2.8rem" borderRadius="14px" className="mb-2" />
);

export const Dashboard = () => {
  const { transactionid } = useParams();
  const [status] = useState(transactionid);
  const [transaction, setTransaction] = useState(false);
  const { overAllCount, loading } = useSelector((state) => state.analytic);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOverAllCount({ startDate: undefined, endDate: undefined }))
      .unwrap()
      .catch(() => {});
  }, [dispatch]);

  const metrics = useMemo(
    () => [
      {
        title: "Total Customers",
        value: overAllCount?.allUsers ?? 0,
        detail: "Complete customer portfolio currently managed in the platform.",
        accent: "brand",
        icon: "pi pi-users",
      },
      {
        title: "Pro Customers",
        value: overAllCount?.proUsers ?? 0,
        detail: "High-value accounts with the most advanced subscription plan.",
        accent: "success",
        icon: "pi pi-star-fill",
      },
      {
        title: "Standard Customers",
        value: overAllCount?.standardUsers ?? 0,
        detail: "Active customers on standard commercial plans.",
        accent: "warning",
        icon: "pi pi-briefcase",
      },
      {
        title: "Trial Customers",
        value: overAllCount?.testUsers ?? 0,
        detail: "Prospects and trial accounts that may convert into paid plans.",
        accent: "danger",
        icon: "pi pi-bolt",
      },
    ],
    [overAllCount]
  );

  return (
    <div className="page-shell">
      <TransactionAlert
        transaction={transaction}
        setTransaction={setTransaction}
        status={status}
      />

      <div className="surface-panel" style={{ marginBottom: "1rem" }}>
        <div className="metric-grid">
          {metrics.map((metric) => (
            <DashboardCard
              key={metric.title}
              title={metric.title}
              count={loading ? loadingMetric : metric.value}
              detail={metric.detail}
              accent={metric.accent}
              icon={metric.icon}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
